import { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';

import store from 'src/store';

import { addConsumer, removeConsumer } from './impl';

type SingleItemRequestResult = {
  incident: ?any,
  loading: ?boolean,
  error: ?any,
}

type LinkedIncidentInfo = {
  incident: ?any,
  loading: ?boolean,
  error: ?any,
  incidentAccountDomain: ?string,
  bySidebarInfo: SingleItemRequestResult,
  byId: SingleItemRequestResult,
  byService: SingleItemRequestResult,
};

export const useLinkedIncident = () : LinkedIncidentInfo => {
  useLayoutEffect(() => {
    addConsumer();
    return () => removeConsumer();
  }, []);

  return useSelector(state => state.linkedIncident);
};

export const getLinkedIncident = () : LinkedIncidentInfo => store.getState().linkedIncident;
